import { render, staticRenderFns } from "./servetype.vue?vue&type=template&id=6bd3cc3e&"
import script from "./servetype.vue?vue&type=script&lang=js&"
export * from "./servetype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports